module.exports = __webpack_public_path__ + "static/media/inf_31og32.876bdd3b.mp3";